export { default } from './pickup-confirmed';
